import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ChannelStore } from '../types'

export const useChannelStore = create<ChannelStore>()(
    persist(
        (set) => ({
            current: null,
            setCurrent: (current) => set({ current })
        }),
        { name: 'channel' }
    )
)
